import { render, staticRenderFns } from "./ComponentProductExchangeDetails.vue?vue&type=template&id=74f80222&"
import script from "./ComponentProductExchangeDetails.vue?vue&type=script&lang=ts&"
export * from "./ComponentProductExchangeDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports